export class HorizontalNavigation {
    constructor(containerSelector, leftArrowSelector, rightArrowSelector, navigationSelector) {
        this.navigation = document.querySelector(navigationSelector);
        
        if (!this.navigation) {
            return;
        }

        this.container = this.navigation.querySelector(containerSelector);
        this.leftArrow = this.navigation.querySelector(leftArrowSelector);
        this.rightArrow = this.navigation.querySelector(rightArrowSelector);

        if (this.container && this.leftArrow && this.rightArrow) {
            this.init();
        } else if (this.container) {
            // Container exists but no arrows - still initialize for auto-scroll
            this.initWithoutArrows();
        }
    }

    init() {
        this.leftArrow.addEventListener('click', () => this.scrollLeft());
        this.rightArrow.addEventListener('click', () => this.scrollRight());

        this.updatePaddles();
        this.scrollToActive();
    }

    initWithoutArrows() {
        this.scrollToActive();
    }

    scrollToActive() {
        const activeItem = this.container.querySelector('.active, .current-menu-item');
        
        if (!activeItem) {
            return;
        }
        
        // Calculate position to center the active item
        const scrollLeft = activeItem.offsetLeft - (this.container.clientWidth / 2) + (activeItem.clientWidth / 2);
        
        // Set scroll position immediately without animation
        this.container.scrollLeft = scrollLeft;
        
        // Mark container as initialized
        if (this.container.parentElement && this.container.parentElement.classList.contains('flex-scroll')) {
            this.container.parentElement.classList.add('initialized');
        }
        
        // Update paddles if they exist
        if (this.leftArrow && this.rightArrow) {
            this.updatePaddles();
        }
    }

    scrollLeft() {
        this.container.scrollBy({
            left: -this.container.clientWidth,
            behavior: 'smooth'
        });
        
        setTimeout(() => this.updatePaddles(), 300);
    }

    scrollRight() {
        this.container.scrollBy({
            left: this.container.clientWidth,
            behavior: 'smooth'
        });
        
        setTimeout(() => this.updatePaddles(), 300);
    }

    updatePaddles() {
        const scrollLeft = this.container.scrollLeft;
        const maxScrollLeft = this.container.scrollWidth - this.container.clientWidth;

        if (scrollLeft <= 0) {
            this.leftArrow.classList.add('hidden');
            this.rightArrow.classList.remove('hidden');
        } else if (scrollLeft >= maxScrollLeft) {
            this.leftArrow.classList.remove('hidden');
            this.rightArrow.classList.add('hidden');
        } else {
            this.leftArrow.classList.remove('hidden');
            this.rightArrow.classList.remove('hidden');
        }
    }
}
